import React, { useEffect, useRef, useState } from 'react'
import { ThemeProvider } from 'styled-components'
import * as Styles from './styles'
import FooterMenu, { IFooterItem } from './footer-menu'
import Logo from '../side-menu/logo'
import LogoGrafeno from '../logo-grafeno'
import Toggler from './toggler'
import { FooterContainer } from './styles'

type Props = {
  'data-qa'?: string
  children: JSX.Element
  collapsed: boolean
  collapseMenuButtonText?: string
  footerMenulist?: IFooterItem[]
  removeLogo?: boolean
  style?: object
  urlLogo?: string
  urlLogoIcon?: string
  onCollapsed?: Function
}

const SideMenuAlt: React.FC<any> = (props: Props) => {
  const [collapsed, setCollapsed] = useState(props.collapsed)
  const onToggle = (newState: boolean): void => setCollapsed(newState)
  const showLogo = !!props.urlLogo
  const [scrollPosition, setScrollPosition] = useState(null)

  const SideMenuAltRef = useRef<HTMLDivElement>()

  function onScroll() {
    const scroll = SideMenuAltRef.current.scrollTop
    setScrollPosition(scroll)
  }

  useEffect(() => {
    if (props.onCollapsed) return props.onCollapsed(collapsed)
  }, [collapsed])

  return (
    <ThemeProvider theme={{ collapsed: collapsed }}>
      <Styles.Container>
        <Styles.SideMenuAlt data-qa={props['data-qa']}>
          {showLogo && !props.removeLogo && (
            <Logo
              compact={collapsed}
              urlImage={props.urlLogo}
              urlImageIcon={props.urlLogoIcon}
              alt={true}
            />
          )}
          {!showLogo && !props.removeLogo && (
            <LogoGrafeno compact={collapsed} alt={true} />
          )}
          <Styles.ContentWrapper
            ref={SideMenuAltRef}
            onScroll={onScroll}
            data-qa={props['data-qa'] && `${props['data-qa']}-content`}
          >
            <Styles.Separator>{props.children}</Styles.Separator>
          </Styles.ContentWrapper>
        </Styles.SideMenuAlt>
        {props.footerMenulist && (
          <FooterContainer>
            <FooterMenu
              itensList={props.footerMenulist}
              data-qa={props['data-qa'] && `${props['data-qa']}-footer`}
            />
          </FooterContainer>
        )}
        {props.collapseMenuButtonText && (
          <Toggler
            data-qa={props['data-qa'] && `${props['data-qa']}-toggler`}
            collapsed={collapsed}
            onToggle={onToggle}
            text={props.collapseMenuButtonText}
          />
        )}
      </Styles.Container>
    </ThemeProvider>
  )
}

SideMenuAlt.defaultProps = {
  removeLogo: false,
}

export default SideMenuAlt
